import { useEffect } from "react";

export default function SEO({ title, description }) {
  useEffect(() => {
    document.title = title;
    let m = document.querySelector('meta[name="description"]');
    if (m && description) m.setAttribute("content", description);
    window.scrollTo(0, 0);
  }, [title, description]);
  return null;
}
